enum LockeysHolderType {
    TEAM,
    ONE_ON_ONE,
    KEY_SUPPORTER,
    HOLDER,
    NON_HOLDER,
}

export default LockeysHolderType